import request from '@/utils/ajax';

/**
 * 发送上报数据
 * @param {Object} data
 */
function _track(data: unknown) {
  return request({
    url: '/exposure/addExposures',
    method: 'post',
    data,
  });
}

/**
 * 事件上报
 * @param {Object} params
 */
export function track(params: unknown) {
  console.log(`Track exposure data to server: ${JSON.stringify(params)}`);
  _track(params);
}

/**
 * 停留时间发送数据
 * @param data
 * @returns
 */
export function stay(data: unknown) {
  console.log(`Track stay data to server: ${JSON.stringify(data)}`);
  return request({
    url: '/stay/addStay',
    method: 'post',
    data,
  });
}
